import { render, staticRenderFns } from "./QuotaTypeSelect.vue?vue&type=template&id=5ffcd91c"
import script from "./QuotaTypeSelect.vue?vue&type=script&lang=ts"
export * from "./QuotaTypeSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports